// @flow
import client from '../../client'
import { config } from '../../config'
import plainSearchResultBuilder from './builders/plainSearchResults'
import format from '../../utils/format'
import poller from '../../utils/poller'
import { isMoreComing, isResultEmpty } from './utils'

// Types
import type { PlainSearchResponse } from '../../models/search'

export type ResultFunc = () => Promise<PlainSearchResponse>
export type Options = {
  reservation_hashed_id: String,
  current_api_provider?: boolean,
}

// API Endpoints
export const PREBOOK_POOL_ENDPOINT = '/search/{0}/poll/'
export const REBOOK_GET_TRIP = '/search/reservation_changes/'

/**
 * Search for a trip by given reservation id with same provider.
 * Returns empty result if no trips with same provider available.
 * @param  {Object} data
 * @return {Object}
 */
export const getRebookSuggestions = (
  data: Options,
  pollAll: boolean = false
): ResultFunc =>
  poller({
    initPoll: () =>
      client.post(REBOOK_GET_TRIP, {
        body: data,
        baseUrl: config.BASE_URL_SEARCH,
      }),
    pollNext: (id, pollId) =>
      client.get(format(PREBOOK_POOL_ENDPOINT, id, pollId), {
        baseUrl: config.BASE_URL_SEARCH,
      }),
    builder: plainSearchResultBuilder,
    isMoreComing,
    isResultEmpty,
    pollAll,
  })

export default getRebookSuggestions
